function openChatBeacon() {
    const beacon = document.querySelector('chatbeacon-button');

    if (!beacon || !beacon.shadowRoot) {
        return false;
    }

    const startChatButton =
        beacon.shadowRoot.querySelector('.start-chat-btn');

    if (!startChatButton) {
        return false;
    }

    startChatButton.click();
    return true;
}

document.addEventListener('click', function (e) {
    const chatLink = e.target.closest('.ihChatLink');

    if (!chatLink) {
        return;
    }

    e.preventDefault();

    // Chat widget is already ready
    if (openChatBeacon()) {
        return;
    }

    // Widget JS may still be loading
    let attempts = 0;

    const waitForChat = setInterval(function () {
        attempts++;

        if (openChatBeacon() || attempts >= 50) {
            clearInterval(waitForChat);
        }
    }, 100);
});
